import { useState } from 'react';
import {
  DragDropProvider,
  Grid,
  Table,
  TableColumnResizing,
  TableHeaderRow,
} from '@devexpress/dx-react-grid-material-ui';
import { Box, fade, Paper, Typography, withStyles } from '@material-ui/core';
import { DataTypeProvider } from '@devexpress/dx-react-grid';
import {
  accountFormatter,
  currencyFormatter,
  renderRelations,
} from '../Shared/colorFormat';
export const getRowId = (row: any) => row.index;

const NumberTypeProvider = (props) => (
  <DataTypeProvider
    formatterComponent={({ value }) => (
      <Typography variant="subtitle2">{Number(value) + 1}</Typography>
    )}
    {...props}
  />
);

const styles = (theme) => ({
  tableStriped: {
    '& tbody tr:nth-of-type(odd)': {
      backgroundColor: fade(theme.palette.primary.main, 0.1),
    },
  },
});

const TableComponentBase = ({ classes, ...restProps }) => (
  <Table.Table {...restProps} className={classes.tableStriped} />
);

export const TableComponent = withStyles(styles, { name: 'TableComponent' })(
  TableComponentBase
);

export default function KaidsTable({ rows, isRTL, words, accounts }: any) {
  const [columns] = useState(
    [
      { name: 'index', title: words.no },
      { name: 'acc', title: words.account },
      { name: 'amountDebit', title: words.amountDebit },
      { name: 'amountCredit', title: words.amountCredit },
      {
        name: 'relations',
        title: isRTL ? 'مراكز التكلفة' : 'Cost Centers',
      },
      { name: 'desc', title: words.description },
    ].filter((x) => x)
  );

  const [tableColumnExtensions]: any = useState([
    { columnName: 'index', width: 70 },
    { columnName: 'acc', width: 200 },
    { columnName: 'amountDebit', width: 120 },
    { columnName: 'amountCredit', width: 120 },
    { columnName: 'relations', width: 200 },
    { columnName: 'desc', width: 200 },
  ]);

  const renderEmpty = () => {
    return <Box display="flex"></Box>;
  };
  return (
    <Paper
      elevation={5}
      style={{
        overflow: 'auto',
        margin: 10,
        minHeight: 250,
      }}
    >
      <Typography style={{ fontWeight: 'bold', padding: 10, fontSize: 22 }}>
        {isRTL ? 'القيود' : 'Entries'}
      </Typography>
      {rows && (
        <Grid rows={rows} columns={columns} getRowId={getRowId}>
          <DragDropProvider />

          <Table
            noDataCellComponent={renderEmpty}
            columnExtensions={tableColumnExtensions}
            tableComponent={TableComponent}
          />
          <TableColumnResizing defaultColumnWidths={tableColumnExtensions} />

          <DataTypeProvider
            for={['amount', 'amountDebit', 'amountCredit']}
            formatterComponent={currencyFormatter}
          ></DataTypeProvider>
          <NumberTypeProvider for={['index']} />
          <DataTypeProvider
            for={['acc']}
            formatterComponent={(props) =>
              accountFormatter(props, accounts, isRTL)
            }
          ></DataTypeProvider>
          <DataTypeProvider
            for={['relations']}
            formatterComponent={(props: any) =>
              renderRelations({ ...props, isRTL })
            }
          ></DataTypeProvider>
          <TableHeaderRow
            titleComponent={({ children }) => {
              return (
                <Typography style={{ fontSize: 14, fontWeight: 'bold' }}>
                  {children}
                </Typography>
              );
            }}
          />
        </Grid>
      )}
    </Paper>
  );
}
